'use client';

import React from 'react';
import { DashboardLayout } from '@/components/layout/DashboardLayout';
import { StockSummary } from '@/components/pages/StockSummary';

export default function DashboardPage() {
  return (
    <DashboardLayout>
      <StockSummary />
    </DashboardLayout>
  );
}
